/**
 * CONFIGURAÇÕES GLOBAIS DE IDENTIDADE E CONTATO
 * Padronização: APS Administrativo - Premium Management
 */

// URL de conversão direta (Call to Action principal)
export const WHATSAPP_URL = "https://wa.me/5511994523137";

// Informações institucionais para Header, Footer e ContactSection
export const CONTACT_INFO = {
  phone: "(11) 99452-3137",
  phoneLink: "tel:+5511994523137",
  email: "ana@apsadministrativo.com.br",
  emailLink: "mailto:ana@apsadministrativo.com.br",
  address: {
    street: "R. Paulo de Morais 132, V. Morais",
    city: "São Paulo/SP",
    cep: "CEP 04168-010",
  },
};

// Links de redes sociais para cards e ícones de interação
export const SOCIAL_LINKS = {
  instagram: "https://www.instagram.com/apsapoioadministrativo",
  facebook: "https://www.facebook.com/apsapoioadministrativo",
};

/**
 * NAVEGAÇÃO PRINCIPAL
 * Mapeamento de IDs para Scroll Smooth e sincronia com o Header
 */
export const NAV_LINKS = [
  { id: "inicio", label: "Início" },
  { id: "servicos", label: "Serviços" },
  { id: "diferenciais", label: "Diferenciais" },
  { id: "clientes", label: "Clientes" },
  { id: "contato", label: "Contato" },
];

// Linha Final: Divisor sutil de fim de arquivo
// ---------------------------------------------------------
